import { AddNewLocation } from "@/components/installFlowV2/add-new-location";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/installFlow/add-new-location")({
  component: AddNewLocation,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
});
